import Dropzone from "react-dropzone";
import {
  createMultipartFileBody,
  getMimeTypeForFileName,
  normalizeFileName,
} from "../../../services/function";
import { useSocialStore } from "../../../stores/social";
import { showToastError } from "../../../services/toast";
import upload from "../../../assets/icons/darkIcons/upload.svg";
import { postDocuments, postDocumentsCustomer } from "../../../api/social";
import { useTranslation } from "react-i18next";

const DepositDocs = () => {
  const { t } = useTranslation();
  const { updateSocial, setUpdateSocial, idEmployee, tabSocial, idCustomer } =
    useSocialStore();

  const uploadFiles = async (acceptedFiles: File[]) => {
    if (acceptedFiles.length === 0) return;

    try {
      const uploadPromises = acceptedFiles.map(async (file) => {
        const normalizedFileName = normalizeFileName(file.name);
        const mimeType = getMimeTypeForFileName(normalizedFileName);

        if (!mimeType) {
          throw new Error("unsupported_file_type");
        }

        const { body, contentType } = await createMultipartFileBody(
          file,
          "file",
          normalizedFileName,
          mimeType,
        );

        const uploadConfig = { headers: { "Content-Type": contentType } };

        return tabSocial === "Bulletins"
          ? postDocumentsCustomer(idCustomer, body, uploadConfig)
          : postDocuments(idEmployee, body, uploadConfig);
      });

      await Promise.all(uploadPromises);
      setUpdateSocial(!updateSocial);
    } catch (err: any) {
      if (err?.message === "unsupported_file_type") {
        showToastError(t("Type de fichier non autorisé"));
      } else if (
        err.response?.data?.message ===
        "Les bulletins sont déja validés pour ce mois"
      ) {
        showToastError(t("Les bulletins sont déja validés pour ce mois"));
      } else if (err.response?.data?.message) {
        showToastError(err.response.data.message);
      } else {
        showToastError(t("Une erreur est survenue lors de l'envoi du document"));
      }
    }
  };

  return (
    <Dropzone noDragEventsBubbling onDropAccepted={uploadFiles}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <div
          {...getRootProps()}
          className={`flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl border-2 border-dashed px-3 py-3 text-center transition-colors ${
            isDragActive
              ? "border-indigo-300 bg-indigo-50/70"
              : "border-slate-200 bg-slate-50 hover:border-indigo-300 hover:bg-indigo-50/50"
          }`}
        >
          <input {...getInputProps()} />
          <img
            src={upload}
            alt=""
            aria-hidden="true"
            className="size-5 shrink-0 opacity-60"
          />

          <p className="font-Nunito text-xs font-semibold text-slate-600 2xl:text-sm">
            {t("Veuillez déposer vos documents ici")}
          </p>
        </div>
      )}
    </Dropzone>
  );
};

export default DepositDocs;
